'use client';

import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal as MUIModal, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { FC, PropsWithChildren, ReactNode } from 'react';

import styles from './Modal.module.scss';

export type ModalProps = {
  title?: ReactNode;
  open: boolean;
  onClose: () => void;
  width?: string;
  styleOptions?: {
    width: string;
    minWidth: string;
    maxWidth: string;
  }; // Не использовать SxProps  https://github.com/vercel/next.js/issues/32314
  variant?: 'default' | 'success' | 'error';
  keepMounted?: boolean;
  children?: ReactNode;
};

const getBackdropClassName = (variant: ModalProps['variant']) => {
  switch (variant) {
    case 'error':
      return styles.backdropError;
    case 'success':
      return styles.backdropSuccess;
    default:
      return '';
  }
};

export const Modal: FC<PropsWithChildren<ModalProps>> = ({
  title,
  open,
  onClose,
  width = '80%',
  styleOptions = {},
  variant = 'default',
  keepMounted,
  children,
}) => {
  const modalContainerSx = Object.assign(
    {
      width: width,
    },
    styleOptions
  ) as any;
  // Если сделать правильно (так как представлено ниже) то будет ошибка сборки
  // Тут можно почитать https://github.com/vercel/next.js/issues/32314
  // as ComponentProps<typeof ModalContainer>['sx'];

  return (
    <MUIModal
      open={open}
      onClose={onClose}
      componentsProps={{
        backdrop: {
          className: getBackdropClassName(variant),
        },
      }}
      keepMounted={keepMounted}
    >
      <ModalContainer sx={modalContainerSx}>
        <CloseButton className={styles.modalCloseButton} onClick={onClose} size="large">
          <CloseIcon />
        </CloseButton>

        <Typography variant="h2">{title}</Typography>

        {children}
      </ModalContainer>
    </MUIModal>
  );
};

const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: theme.palette.background.default,
  borderRadius: '6px',
  padding: '0.25rem 1.5rem 0.875rem 1.5rem ',
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '1.5rem',
  right: '1.5rem',
  backgroundColor: theme.palette.background.defaultButton,
  borderRadius: '6px',
}));
